<template>
  <div class="space-y-2 mb-4">
    <tags v-for="tag in loyaltyTagsData" :key="tag.type" :type="tag.type" :title="tag.name"
          :content="tag.title"/>
  </div>
</template>

<script setup>
import Tags from "@/components/product/loyalty/Tags";

const props = defineProps({
  data: {
    type: Object,
    default: () => {
    }
  },
  selectedOption: {
    type: Object,
    default: () => {
    }
  }
});

const selectedProductOption = computed(() => props.selectedOption?.defaultOption || props.selectedOption?.secondaryOption)
const loyaltyTagsData = computed(() => props.data?.loyalty_details?.available_tiers || selectedProductOption.value?.loyalty_details?.available_tiers)
</script>
